import Carousel from "react-material-ui-carousel";
import CarouselPagination from "./CarouselPagination";
import PollWidgetCard from "./PollWidgetCard";
import React from "react";
import axios from "axios";
import { Link } from "@mui/material";
import { connect } from "react-redux";
import { POLLS_API_URL } from "../../Polls/Polls";

const PollsWidget = (props) => {
    const [polls, setPolls] = React.useState([]);
    const [isShowThanksForVotingMessage, setIsShowThanksForVotingMessage] =
        React.useState(false);
    const [shouldChangeToNextPoll, setShouldChangeToNextPoll] =
        React.useState(false);
    const [currentCarouselIndex, setCurrentCarouselIndex] = React.useState(0);
    const [currentSessionVotedPolls, setCurrentSessionVotedPolls] =
        React.useState([]);
    const [canNavigateToNextPoll, setCanNavigateToNextPoll] =
        React.useState(true);
    const [votedAnswerIds, setVotedAnswerIds] = React.useState([]);
    const [ pollsViewed, setPollsViewed ] = React.useState([]);

    React.useEffect(() => {
        getPollsList();
    }, []);

    React.useEffect(() => {
        setCanNavigateToNextPoll(true);

        if (polls.length > 0) {
            markPollAsViewed(currentCarouselIndex);
        }
    }, [currentCarouselIndex]);

    React.useEffect(() => {
        if (polls.length > 0) {
            markPollAsViewed(currentCarouselIndex);
        }
    }, [ polls ]);

    const showThanksForVotingMessage = () => {
        setIsShowThanksForVotingMessage(true);
        setTimeout(() => {
            setIsShowThanksForVotingMessage(false);
        }, 3000);
    };

    const pollHasBeenVoted = (setPollVoted) => {
        if (setPollVoted) {
            setPollVoted(false);
        }
    };

    const filterVotedPolls = (polls) => {
        return polls.filter((poll) => {
            return poll.voted;
        });
    };

    const indicesOfVotedPolls = (polls) => {
        return filterVotedPolls(polls).map((poll) => {
            return polls.indexOf(poll);
        });
    };

    const addPollIdToSessionVotedPolls = (pollId) => {
        if (!isPollIdInSessionVotedPolls(pollId)) {
            setCurrentSessionVotedPolls([...currentSessionVotedPolls, pollId]);
        }
    };

    const isPollIdInSessionVotedPolls = (pollId) => {
        return currentSessionVotedPolls.indexOf(pollId) !== -1;
    };

    const updateVotedPollAnswer = (pollId, {data: answer}) => {
        const poll = polls.find((poll) => {
            return poll.id === pollId;
        });

        const updatedPollsAnswers = poll.question.answers.map((answerItem) => {
            if (answerItem.id === answer.id) {
                return answer;
            }
            return answerItem;
        });

        const updatedPoll = {
            ...poll,
            question: {
                ...poll.question,
                responses: poll.question.responses + 1,
                answers: updatedPollsAnswers,
            },
            voted: true,
        };

        updateVotedPoll(updatedPoll);
        setVotedAnswerIds([...votedAnswerIds, answer.id]);
    };

    const updateVotedPoll = (updatedPoll) => {
        const updatedPolls = polls.map((poll) => {
            if (poll.id === updatedPoll.id) {
                return updatedPoll;
            }
            return poll;
        });

        setPolls(updatedPolls);
    };

    const getPollsList = () => {
        axios.get(`${POLLS_API_URL}unanswered-polls`).then(async (res) => {
            const polls = res.data.items;
            setPolls(polls);
        });
    };

    const markPollAsViewed = (index) => {
        let currentPoll = polls[index];

        if (!pollsViewed.includes(currentPoll.id)) {
            axios.post(`${POLLS_API_URL}polls/${currentPoll.id}/viewed`)
                .then(response => {
                    let localPollsViewed = [ ...pollsViewed ];
                    localPollsViewed.push(currentPoll.id);
                    setPollsViewed(localPollsViewed);
                })
                .catch(error => {

                });
        }
    }

    {
        return (
            polls.length > 0 && (
                <>
                    <div className="grid-x align-middle">
                        <div className="cell small-5">
                            <h2>Quick Poll</h2>
                        </div>
                    </div>
                    <div className="box-shadow bg-widget content-padding">
                        <Carousel
                            className="polls-carousel"
                            autoPlay={shouldChangeToNextPoll}
                            index={currentCarouselIndex}
                            stopAutoPlayOnHover={false}
                            interval={5000}
                            indicators={false}
                            fullHeightHover={false} // We want the nav buttons wrapper to only be as big as the button element is
                            cycleNavigation={false}
                            navButtonsWrapperProps={{
                                // Move the buttons to the bottom. Unsetting top here to override default style.
                                style: {
                                    bottom: "unset",
                                    top: "unset",
                                    zIndex: 1,
                                    padding: "0 11px",
                                },
                            }}
                            onChange={(index) => {
                                if (index !== currentCarouselIndex) {
                                    setCurrentCarouselIndex(index);
                                }
                            }}
                            NavButton={({ onClick, next, prev }) => {
                                return (
                                    <Link
                                        onClick={() => {
                                            if (canNavigateToNextPoll) {
                                                onClick();
                                                setIsShowThanksForVotingMessage(
                                                    false
                                                );
                                            }
                                            setCanNavigateToNextPoll(false);
                                        }}
                                        className="carousel-button"
                                    >
                                        {prev
                                            ? isShowThanksForVotingMessage
                                                ? ""
                                                : "< Prev Poll"
                                            : ""}
                                        {next && "Next Poll >"}
                                    </Link>
                                );
                            }}
                        >
                            {polls &&
                                polls.map((poll) => {
                                    return (
                                        <PollWidgetCard
                                            poll={poll}
                                            key={poll.id}
                                            showResults={true}
                                            showThanksForVotingMessage={
                                                showThanksForVotingMessage
                                            }
                                            setShouldChangeToNextPoll={
                                                setShouldChangeToNextPoll
                                            }
                                            addPollIdToSessionVotedPolls={
                                                addPollIdToSessionVotedPolls
                                            }
                                            pollHasBeenVoted={pollHasBeenVoted}
                                            updateVotedPollAnswer={
                                                updateVotedPollAnswer
                                            }
                                            votedAnswerIds={votedAnswerIds}
                                        />
                                    );
                                })}
                        </Carousel>

                        { polls.length > 1 &&
                            <CarouselPagination
                                currentPage={currentCarouselIndex}
                                totalPages={polls.length}
                                highlightedPages={indicesOfVotedPolls(polls)}
                                onPageChange={(page) => {
                                    setCurrentCarouselIndex(page);
                                    setShouldChangeToNextPoll(false);
                                }}
                            >
                                {isShowThanksForVotingMessage && (
                                    <span className="voting-message">
                                        Thanks for voting!
                                    </span>
                                )}
                            </CarouselPagination>
                        }
                    </div>
                </>
            )
        );
    }
};

const mapStateToProps = (state) => {
    return {
        searchText: state.module['POLLS'].polls.logFilterText,
    };
};

export default connect(mapStateToProps)(PollsWidget);
